export enum FilterEventByOpennessType {
  All = "All",
  Private = "Private",
  Public = "Public",
}
